export default function RrhhPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-2">Recursos Humanos</h1>
      <p className="text-sm text-espresso-500">
        Esta sección está en construcción — vuelve pronto.
      </p>
    </div>
  )
}
